export default {"src":"/_next/static/media/email.5769e77f.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};